import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../../models';

/** Representa o Filter da entidade RegiaoGeograficaIntermediaria */
export class TituloReceberResumoFilter implements Filter {
    idsPessoas: number[];
    idRepresentante: number;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Pessoas
        if (this.idsPessoas) {
            this.idsPessoas.forEach(idPessoa => {
                params = params.append('idPessoa', idPessoa.toString());
            });
        }

        // Representante
        if (this.idRepresentante) {
            params = params.append('idRepresentante', this.idRepresentante.toString());
        }

        return params;
    }

    clear() {
        this.idsPessoas = [];
        this.idRepresentante = null;
    }
}

